const routerArr = [

    // {
    //     path: '/',
    //     meta: { title:'登录' , login:false },
    //     redirect: { path: '/login' },
    //     component: () => import(/* webpackChunkName: 'education' */ './page/login.vue'),
    // },

    {
        path: '/',
        meta: { title:'首页' , login:false },
    },
    {
      path: '/login',
      name: 'login',
      meta: { title:'登录',login:false },
      component: () => import(/* webpackChunkName: 'account' */ './page/logIn.vue'),
  },

  {
      path: '/verification',
      name: 'verification',
      meta: { title:'重置密码',login:false },
      component: () => import(/* webpackChunkName: 'account' */ './page/verification.vue'),
  },
 {
    path: '/verificationCode',
    name: 'verificationCode',
    meta: { title:'验证码' ,login:false},
    component: () => import(/* webpackChunkName: 'account' */ './page/verificationCode.vue'),
  },
  {
    path: '/registered',
    name: 'registered',
    meta: { title:'注册',login:false },
    component: () => import(/* webpackChunkName: 'account' */ './page/registered.vue'),
  },
  {
    path: '/resetPassword',
    name: 'resetPassword',
    meta: { title:'设置密码',login:false },
    component: () => import(/* webpackChunkName: 'account' */ './page/resetPassword.vue'),
  },
  {
    path: '/orderpage',
    name: 'orderpage',
    meta: { title:'我的订单',login:true  },
    component: () => import(/* webpackChunkName: 'account' */ './page/orderpage.vue'),
  },
  {
    path: '/evaluate',
    name: 'evaluate',
    meta: { title:'评价',login:true  },
    component: () => import(/* webpackChunkName: 'account' */ './page/evaluate.vue'),
  },
  {
    path: '/lookEvaluate',
    name: 'lookEvaluate',
    meta: { title:'查看评价',login:true, look:true },
    component: () => import(/* webpackChunkName: 'account' */ './page/evaluate.vue'),
  },
  {
    path: '/idcard',
    name: 'idcard',
    meta: { title:'实名认证' ,login:true},
    component: () => import(/* webpackChunkName: 'account' */ './page/IdCard.vue'),
  },
  {
    path: '/idcardconfirm',
    name: 'idcardconfirm',
    meta: { title:'实名认证' ,login:true},
    component: () => import(/* webpackChunkName: 'account' */ './page/IdCardConfirm.vue'),
  },
  {
    path: '/scan',
    name: 'scan',
    meta: { title:'实名认证',login:true },
    component: () => import(/* webpackChunkName: 'account' */ './page/ScanFace.vue'),
  },
  {
    path: '/authsucc',
    name: 'authsucc',
    meta: { title:'实名认证',login:true },
    component: () => import(/* webpackChunkName: 'account' */ './page/AuthSucc.vue'),
  },
  {
    path: '/authfail',
    name: 'authfail',
    meta: { title:'实名认证' ,login:true},
    component: () => import(/* webpackChunkName: 'account' */ './page/AuthFail.vue'),
  },
  {
    path: '/about',
    name: 'about',
    meta: { title:'学员端' ,login:true},
    component: () => import(/* webpackChunkName: 'account' */ './page/about.vue'),
  },
  {
    path: '/assess',
    name: 'assess',
    meta: { title:'学员端',login:true },
    component: () => import(/* webpackChunkName: 'account' */ './page/assess.vue'),
  },
  {
    path: '/setting',
    name: 'setting',
    meta: { title:'学员端' ,login:true},
    component: () => import(/* webpackChunkName: 'account' */ './page/setting.vue'),
  },
  {
    path: '/edit',
    name: 'edit',
    meta: { title:'学员端' ,login:true},
    component: () => import(/* webpackChunkName: 'account' */ './page/edit.vue'),
  },
  {
    path: '/invoicesinfo',
    name: 'invoicesinfo',
    meta: { title:'学员端' ,login:true},
    component: () => import(/* webpackChunkName: 'account' */ './page/invoicesInfo.vue'),
  },
  {
    path: '/invoicesForm',
    name: 'invoicesForm',
    meta: { title:'学员端' ,login:true},
    component: () => import(/* webpackChunkName: 'account' */ './page/invoicesForm.vue'),
  },
  {
    path: '/identification',
    name: 'identification',
    meta: { title:'学员端' ,login:true},
    component: () => import(/* webpackChunkName: 'account' */ './page/identification.vue'),
  },
  {
    path: '/certificate',
    name: 'certificate',
    meta: { title:'我的证书' ,login:true},
    component: () => import(/* webpackChunkName: 'account' */ './page/certificate.vue'),
  },
  {
    path: '/certificate/validation',
    name: 'certificateValidation',
    meta: { title:'证书验证' ,login:true},
    component: () => import(/* webpackChunkName: 'account' */ './page/certificateValidation.vue'),
  },
  {
    path: '/myProfile',
    name: 'myProfile',
    meta: { title:'我的资料',login:true },
    component: () => import(/* webpackChunkName: 'account' */ './page/myProfile.vue'),
  },
  {
    path: '/editProfile',
    name: 'editProfile',
    meta: { title:'编辑资料' ,login:true},
    component: () => import(/* webpackChunkName: 'account' */ './page/editProfile.vue'),
  },
  {
    path: '/personAccount',
    name: 'personAccount',
    meta: { title:'账号安全' ,login:true},
    component: () => import(/* webpackChunkName: 'account' */ './page/personAccount.vue'),
  },
  {
    path: '/modifyPassword',
    name: 'modifyPassword',
    meta: { title:'修改密码',login:true },
    component: () => import(/* webpackChunkName: 'account' */ './page/modifyPassword.vue'),
  },
  {
    path: '/modifyPhone',
    name: 'modifyPhone',
    meta: { title:'绑定/更换手机',login:true },
    component: () => import(/* webpackChunkName: 'account' */ './page/modifyPhone.vue'),
  },
  {
    path: '/modifyMail',
    name: 'modifyMail',
    meta: { title:'绑定/更换邮箱',login:true },
    component: () => import(/* webpackChunkName: 'account' */ './page/modifyMail.vue'),
  },
     // 人社分销相关协议法规start
     {
      path: '/registerProtocol',
      name: 'registerProtocol',
      meta: { title:'用户注册协议' , login:false },
      component: () => import(/* webpackChunkName: 'registerProtocol' */ './page/renshefenguan/protocol.vue'),
  },
  {
      path: '/user-privacy',
      name: 'UserPrivacy',
      meta: { title:'个人信息保护制度' , login:false },
      component: () => import(/* webpackChunkName: 'UserPrivacy' */ './page/renshefenguan/privacy.vue'),
  },
  {
      path: '/network-regulation',
      name: 'NetworkRegulation',
      meta: { title:'网络安全管理制度' , login:false },
      component: () => import(/* webpackChunkName: 'NetworkRegulation' */ './page/renshefenguan/regulation.vue'),
  },
  // 人社分销相关协议法规end
  {
    path: '/service-agreement',
    name: 'service-agreement',
    meta: { title:'用户协议' ,login:false},
    component: () => import(/* webpackChunkName: 'account' */ './page/service-agreement.vue'),
  },
  {
    path: '/privacy',
    name: 'privacy',
    meta: { title:'法律声明及隐私政策',login:false },
    component: () => import(/* webpackChunkName: 'account' */ './page/privacy.vue'),
  },
  {
    path: '/service-agreement',
    name: 'service-agreement',
    meta: { title:'用户协议' ,login:false},
    component: () => import(/* webpackChunkName: 'account' */ './page/service-agreement.vue'),
  },
  {
    path: '/testreport',
    name: 'testreport',
    meta: { title:'我的测评' ,login:true},
    component: () => import(/* webpackChunkName: 'account' */ './page/testreport.vue'),
  },
  {
    path: '/saccount',
    name: 'saccount',
    meta: { title:'学员端' ,login:true},
    component: () => import(/* webpackChunkName: 'account' */ './page/index.vue'),
  },
  {
    path: '/toC',
    name: 'toC',
    meta: { title:'伟东云职业教育生态平台' ,login:false},
    component: () => import(/* webpackChunkName: 'toC' */ './page/toC.vue'),
  },
  {
    path: '/platformEvaluation',
    name: 'platformEvaluation',
    meta: { title:'服务点评' ,login:true},
    component: () => import(/* webpackChunkName: 'toC' */ './page/platformEvaluation.vue'),
  },
  {
    path: '/offllineOrderCertificate',
    name: 'offllineOrderCertificate',
    meta: { title:'电子凭证' ,login:true},
    component: () => import(/* webpackChunkName: 'toC' */ './page/offllineOrderCertificate.vue'),
  },
  {
    path: '/myPoints',
    name: 'myPoints',
    meta: { title:'我的积分' ,login:true},
    component: () => import(/* webpackChunkName: 'toC' */ './page/myPoints.vue'),
  },
  {
    path: '/pointsRules',
    name: 'pointsRules',
    meta: { title:'我的积分' ,login:true},
    component: () => import(/* webpackChunkName: 'toC' */ './page/pointsRules.vue'),
  },
  {
    path: '/couponPage',
    name: 'couponPage',
    meta: { title:'优惠券' ,login:true},
    component: () => import(/* webpackChunkName: 'toC' */ './page/couponPage.vue'),
  },
  // {
  //   path: '/demo_homepage',
  //   name: 'demo',
  //   meta: { title:'学员端' ,login:false},
  //   component: () => import(/* webpackChunkName: 'account' */ './page/demo.vue'),
  // },
  {
    path: '/myDeclareCertProfile',
    name: 'myDeclareCertProfile',
    meta: { title:'我的报证' ,login:true},
    component: () => import(/* webpackChunkName: 'account' */ './page/myDeclareCertProfile.vue'),
  },
]
export default routerArr
